<template>
    <div class="">
        <b-modal size="lg" no-close-on-backdrop no-close-on-esc title="View" ok-only @ok="cerrar"
        v-model="show_pdf"  id="modalError" ok-title="Cerrar">
            <b-row>
                <b-col cols="12" class="overflow-auto">
                    <embed :src="url" width="760" height="480" type="application/pdf"></embed>
                </b-col>
            </b-row>
        </b-modal>
    </div>
    
  </template>
  
  
  <script>
    import {mapState, mapActions, mapMutations} from 'vuex';
    
    export default {
      name: 'ViewPDF',
      components: {
        
      },
      data () {
        return {
          show_pdf: false
        }
      },
      props: {
        url:String,
        show_detail: Boolean
      },
      mounted () {
        this.show_pdf = this.show_detail;
        if (!this.url) {
          this.setWarning('No tiene un archivo cargado', { root: true }).then(()=>{
            this.cerrar();
          })
        }
      },
      
      methods:{
          ...mapActions({
              setWarning: 'setWarning',
          }),
        ...mapMutations({
          
        }),
        
        cerrar() {
          this.show_pdf = false;
          this.$emit("cerrar")
        }
  
      },
      computed:{
        ...mapState({
          detalle: state => state.temas.detalle, 
          warning: state => state.warning,
          detalle_curso: state => state.cursos.detalle, 
        }),
  
        curso(){
          return this.detalle_curso[this.curso_id]
        },
        
      },
      watch: {
        show_detail: function(newVal, oldVal) {
          this.show_pdf = newVal;
        }
      }
    }
  </script>
  
  <style scope>
  
    .perfil_wrapper .container{
        background-color: #fff;
        padding: 15px;
    }
  </style>
  